module.exports = __webpack_public_path__ + "img/img_bib_logo_bg_right.f3e4c587.png";